module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-feature-img-1-bcfbef184fcca5ef17599eeb69443ede.png";